<template>
  <QuestionsCard
    :cards="cards"
    :resolved="resolved"
    :superseded="superseded"
    :rows-of="(question) => question.options"
    :value-of="(option) => option.label"
    :key-of="(label) => label"
    @submit="$emit('submit', $event)"
  >
    <template #row="{ row }">
      <span class="choice">
        <span class="choice__label">
          {{ row.label }}
          <span v-if="row.recommended" class="choice__chip">Recommended</span>
        </span>
        <span v-if="row.description" class="choice__description">{{
          row.description
        }}</span>
      </span>
    </template>
  </QuestionsCard>
</template>

<script>
import QuestionsCard from "@/components/OliverBotV2/interactions/shared/QuestionsCard.vue";

/** Oliver's written questions: options it wrote, one or several picked. */
export default {
  name: "ChoiceCard",
  components: { QuestionsCard },
  props: {
    cards: { type: Array, required: true },
    resolved: { type: Object, default: null },
    superseded: { type: Boolean, default: false },
  },
  emits: ["submit"],
};
</script>

<style lang="scss" scoped>
.choice {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.choice__label {
  font-size: 13px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.choice__chip {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 7px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;
  vertical-align: middle;
  background: rgba(127, 127, 127, 0.18);
  color: var(--oliver-text-muted);
}

.choice__description {
  font-size: 11px;
  color: var(--oliver-text-muted);
  overflow-wrap: anywhere;
}
</style>
